export default __webpack_public_path__ + "static/media/A40D.b9acee84.pdf";